import React from "react";
import PropTypes from "prop-types";
import { Spin } from "antd";
import "./spinner.css";

const Spinner = ({ className, style, message }) => {
  return (
    <div className={`cp-spinner ${className}`} style={style}>
      <Spin size="large" />
      <h4>{message}</h4>
    </div>
  );
};

Spinner.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  message: PropTypes.string
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/views/components/spinner/Spinner.jsx